import { NamedResource } from '@core/resources/resource';
import { DomainList } from './domain-list/domain-list';

export type DestinationType = 'domain_list' | 'category' | 'theme' | 'all';

export const DESTINATION_ICONS = {
  all: 'public',
  theme: 'local_offer',
  category: 'local_offer',
  domain_list: 'list_alt'
};

export interface DestinationsInput {
  domain_lists_ids?: string[];
  domain_lists: Destination<DomainList>[] | DomainList[];
  theme_ids: string[];
  category_ids: string[];
}

/**
 * User defined Type Guard. Use in an If statement, like instanceof, so the compiler can narrow the type
 */
export function isDestination(arg: NamedResource): arg is Destination {
  return (arg as Destination).type === 'theme' || (arg as Destination).type === 'category' ||
          (arg as Destination).type === 'domain_list' || ((arg as Destination).type === 'all' && (arg as Destination).hasOwnProperty('getFullName'));
}

export interface Destination<T = NamedResource> {
  readonly type: DestinationType;
  readonly icon: string;
  id: string;
  name: string;

  /**
   * Use to warn user about duplicated destinations across rules of a same policy
   * contains rules's indexes where duplicates can be found.
   */
  warning: string[];

  clone: () => T;

  getFullName: () => string;

  getCount: () => string;

  setWarning: (payload: string) => void;

  clearWarning: () => void;
}

export class AllDestination extends NamedResource implements Destination<AllDestination> {
  readonly type = 'all';
  readonly icon = DESTINATION_ICONS.all;
  override id = 'all-destination';
  override name: string;
  warning: string[] = [];

  constructor(name: string) {
    super();
    this.name = name;
  }

  clone(): AllDestination {
    return new AllDestination(this.name);
  }

  getFullName(): string {
    return this.name;
  }

  getCount(): string {
    return '';
  }

  setWarning(payload: string): void {
    if (!this.warning.includes(payload)) {
      this.warning.push(payload);
    }
  }

  clearWarning(): void {
    this.warning = [];
  }
}

export class DestinationEvent {
  value: Destination;
  constructor(obj: Destination) {
    this.value = obj;
  }
}
